<template>
  <div>
    <DxPopup
      :visible="isVisible"
      :hide-on-outside-click="false"
      :title="title"
      :drag-enabled="false"
      :wrapperAttr="{ class: 'css-v2 gc-popup' }"
      :onHiding="onHiding"
      :height="550"
    >
      <div class="css-v2 gc-popup-form">
        <gc-form
          :formOptions="{
            gcLabelLocation: 'left',
          }"
          :formItems="getFormItems"
          :formHeight="70"
          :isNormal="true"
          :data-model="formDataModel"
          :formMode="'create'"
          :validationGroup="'gcPopupConfig-gc-popup-form-data'"
          :formTitle="'gc-popup'"
          :ref="'add-item-popup-form'"
        ></gc-form>
      </div>

      <div class="css-v2 transaction-list">
        <DxDataGrid
          :columns="pickingSlipDataGridColumns()"
          :data-source="pickingSlipDetails"
          :columnChooser="{ enabled: false }"
          :searchPanel="{ visible: false }"
          :selection="{ selectAllMode: 'allMode', mode: 'multiple' }"
          keyExpr="ItemCode"
          :selectedRowKeys.sync="selectedRowKeys"
          :height="340"
          ref="pickingSlipDetailGridRef"
          @editor-preparing="onEditorPreparing"
        >
          <template #product-cell-template="{ data }">
            <GcRecord
              :data="data"
              :primary="[{ dataField: 'ItemDescription' }]"
              :secondary="[{ dataField: 'ItemCode' }]"
              :showImage="true"
            />
          </template>

          <DxEditing
            :allow-updating="true"
            :allow-deleting="false"
            mode="cell"
          />
        </DxDataGrid>
      </div>

      <div class="footer so-part-pick-popup-footer">
        <DxButton
          text="Save"
          type="default"
          styling-mode="contained"
          class="save-btn"
          @click="savePartPick()"
          :disabled="this.saveDisabled()"
          :ref="'footer-save-btn'"
        />
        <DxButton
          text="Cancel"
          type="default"
          styling-mode="contained"
          class="cancel-btn"
          @click="cancelPartPicking"
        />
      </div>
    </DxPopup>
  </div>
</template>

<script>
import { DespatchOrderService } from "../_services/api/sales/despatch-order.service";
import { SalesOrderService } from "../_services/api/sales/sales-order.service";
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    salesOrderCode: {
      type: Number,
      default: undefined,
    },
    customerName: {
      type: String,
      default: undefined,
    },
    customerCode: {
      type: String,
      default: undefined,
    },
    shipDate: {
      type: Date,
      default: undefined,
    },
    requiredByDate: {
      type: Date,
      default: undefined,
    },
    callback: {
      type: Function,
      default: function () {},
    },
    setLoading: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      formDataModel: {
        SalesOrderCode: undefined,
        Customer: undefined,
        ShipDate: undefined,
        RequiredByDate: undefined,
      },
      aRowIsSelected: false,
      pickingSlipHeaderLoaded: false,
      pickingSlipDetails: [],
      pickingSlipDetailsLoaded: false,
      quantityFormat: "##,###,###,###,##0.00",
      selectedRowKeys: [],
      aSelectedRowHasZeroPickedQuantity: false,
      pickingSlipHeaderInformation: {
        DeliveryAddressCompanyName: undefined,
        DeliveryAddressCountry: undefined,
        DeliveryAddressPostcode: undefined,
        DeliveryAddressState: undefined,
        DeliveryAddressStreetLine1: undefined,
        DeliveryAddressStreetLine2: undefined,
        DeliveryAddressSuburb: undefined,
        Comment: undefined,
        RaisedBy: undefined,
      },
    };
  },
  async mounted() {
    this.setLoading(true);
    this.formDataModel.SalesOrderCode = `${this.salesOrderCode}`;
    this.formDataModel.Customer = this.customerName;
    this.formDataModel.ShipDate = this.shipDate.toShortDateString();
    this.formDataModel.RequiredByDate = this.requiredByDate.toShortDateString();

    await DespatchOrderService.getDespatchOrderCode(this.salesOrderCode).then(
      (res) => {
        let pickingSlipHeader = res.data.value[0];
        this.pickingSlipHeaderInformation.DeliveryAddressCompanyName =
          pickingSlipHeader.DeliveryAddressCompanyName;
        this.pickingSlipHeaderInformation.DeliveryAddressCountry =
          pickingSlipHeader.DeliveryAddressCountry;
        this.pickingSlipHeaderInformation.DeliveryAddressPostcode =
          pickingSlipHeader.DeliveryAddressPostcode;
        this.pickingSlipHeaderInformation.DeliveryAddressState =
          pickingSlipHeader.DeliveryAddressState;
        this.pickingSlipHeaderInformation.DeliveryAddressStreetLine1 =
          pickingSlipHeader.DeliveryAddressStreetLine1;
        this.pickingSlipHeaderInformation.DeliveryAddressStreetLine2 =
          pickingSlipHeader.DeliveryAddressStreetLine2;
        this.pickingSlipHeaderInformation.DeliveryAddressSuburb =
          pickingSlipHeader.DeliveryAddressSuburb;
        this.pickingSlipHeaderInformation.RaisedBy = pickingSlipHeader.RaisedBy;
        this.pickingSlipHeaderLoaded = true;
      }
    );

    await SalesOrderService.getConsolidatedSalesOrderMaterialBySalesOrderCode(
      this.salesOrderCode
    )
      .then((res) => {
        res.data.value.forEach((pickingSlipLine) => {
          // pickingSlipLine.IsBatchProduct == "No" &&  > Removed
          if (pickingSlipLine.OsQty != 0) {
            let pickingSlipDetailRow = {
              ItemCode: pickingSlipLine.MaterialCode,
              ItemDescription: pickingSlipLine.ItemDescription,
              OrderedQuantity: pickingSlipLine.OrderQty,
              OutstandingQuantity: pickingSlipLine.OsQty,
              PickedQuantity: 0.0,
              UM: pickingSlipLine.UM,
              Comment: "",
              SuppliedQuantity: pickingSlipLine.ActualQty,
              ItemType: pickingSlipLine.ItemType,
            };
            this.pickingSlipDetails.push(pickingSlipDetailRow);
          }
        });
        this.pickingSlipDetailsLoaded = true;
        this.setLoading(false);
      })
      .catch(() => {
        this.callback(false);
        this.setLoading(false);
      });
  },
  computed: {
    isVisible() {
      return (
        this.visible &&
        this.pickingSlipDetailsLoaded &&
        this.pickingSlipHeaderLoaded
      );
    },
    title() {
      return `Part Picking Slip for Sales Order ${this.salesOrderCode}`;
    },
    getFormItems() {
      return [
        {
          itemType: "group",
          caption: "",
          colCount: 2,
          items: [
            {
              itemType: "group",
              caption: "",
              items: [
                {
                  screenField: "Code",
                  editorOptions: {
                    allowUpdate: false,
                  },
                  dataField: "SalesOrderCode",
                  label: {
                    text: "Sales Order",
                  },
                },
                {
                  dataField: "Customer",
                  editorOptions: {
                    allowUpdate: false,
                  },
                  label: {
                    text: "Customer",
                  },
                },
              ],
            },
            {
              itemType: "group",
              caption: "",
              items: [
                {
                  dataField: "ShipDate",
                  editorOptions: {
                    allowUpdate: false,
                  },
                  label: {
                    Text: "Shipping Date",
                  },
                },
                {
                  dataField: "RequiredByDate",
                  editorOptions: {
                    allowUpdate: false,
                  },
                  label: {
                    text: "Required by Date",
                  },
                },
              ],
            },
          ],
        },
      ];
    },
  },
  methods: {
    onEditorPreparing(e) {
      if (
        (e.dataField == "PickedQuantity" || e.dataField == "Comment") &&
        e.parentType == "dataRow"
      ) {
        if (e.row.isSelected) {
          e.editorOptions.disabled = false;
          if (
            e.dataField == "PickedQuantity" &&
            e.row.data.PickedQuantity == 0
          ) {
            e.row.data.PickedQuantity = e.row.data.OutstandingQuantity;
          }
        } else {
          e.editorOptions.disabled = true;
        }
      }
    },
    getSelectedRows() {
      return this.$refs[
        "pickingSlipDetailGridRef"
      ].instance.getSelectedRowsData();
    },
    saveDisabled() {
      if (this.selectedRowKeys.length == 0) {
        return true;
      } else {
        if (this.aSelectedRowHasZeroPickedQuantity) {
          this.$refs["pickingSlipDetailGridRef"].instance.getSelectedRowsData(
            (row) => {
              if (row.PickedQuantity <= 0) return true;
            }
          );
        }
        return false;
      }
    },
    async savePartPick() {
      let selectedRows = this.getSelectedRows();
      let payload = {
        SalesOrderCode: this.salesOrderCode,
        CustomerCode: this.customerCode,
        OrderNo: this.orderNumber,
        ShipDate: this.shipDate,
        SalesOrderDetails: [],
        ...this.pickingSlipHeaderInformation,
      };
      selectedRows.forEach((row) => {
        let detail = {
          Include: "Y",
          MaterialCode: row.ItemCode,
          OrderQty: row.OrderedQuantity,
          SuppliedQty: row.SuppliedQuantity,
          BackOrderQty: row.OutstandingQuantity,
          PickQty: row.PickedQuantity,
          Comment: row.Comment,
          ItemType: row.ItemType,
          UM: row.UM,
        };
        payload.SalesOrderDetails.push(detail);
      });
      this.setLoading(true);
      await SalesOrderService.partPickSalesOrder(payload)
        .then(() => {
          this.setLoading(false);
          this.callback(true);
        })
        .catch(() => {
          this.setLoading(false);
          this.callback(false);
        });
    },
    cancelPartPicking() {
      this.callback();
    },
    onHiding() {
      this.callback();
    },
    pickingSlipDataGridColumns() {
      return [
        {
          caption: "Product / Account",
          dataField: "ItemCode",
          cellTemplate: "product-cell-template",
          allowEditing: false,
        },
        {
          caption: "Ordered",
          dataField: "OrderedQuantity",
          allowEditing: false,
          format: this.quantityFormat,
        },
        {
          caption: "Outstanding",
          dataField: "OutstandingQuantity",
          allowEditing: false,
          format: this.quantityFormat,
        },
        {
          caption: "Picked",
          dataField: "PickedQuantity",
          allowEditing: true,
          cssClass: "edit-cell-numberbox-field",
          format: this.quantityFormat,
          showEditorAlways: true,
          editorOptions: {
            onFocusIn: (e) => {
              e.event.target.select();
            },
            min: 1,
            format: this.quantityFormat,
            step: 0,
          },
        },
        {
          caption: "Comment",
          dataField: "Comment",
          allowEditing: true,
          cssClass: "edit-cell-textbox-field",
          showEditorAlways: true,
          editorOptions: {
            onFocusIn: (e) => {
              e.event.target.select();
            },
          },
        },
      ];
    },
  },
};
</script>

<style lang="scss">
.so-part-pick-popup-footer {
  padding-top: 10px;
  bottom: 0;
  margin-right: 0px;
  height: 45px;
  text-align: right;

  .save-btn {
    margin-right: 10px;
    background-color: #8bc34a;
  }

  .cancel-btn {
    margin-right: 0px;
    background-color: #ff0033;
  }
}
</style>
